module.exports = __webpack_public_path__ + "img/admin_adv_28.5c6b4b8c.png";